// extracted by mini-css-extract-plugin
module.exports = {"card":"style-module__card___emR8d","sectionName":"style-module__sectionName____3MNr"};